import { IoAddCircle } from 'react-icons/io5';
import { AdminTanque, Dot } from '../../styles/admin';
import { apiJalles } from '../../services/api';
import { HomeContext } from '../../contexts/contexHome';
import { useContext, useEffect, useState } from 'react';
import { ImBin } from 'react-icons/im';
import { CiEdit } from 'react-icons/ci';
import imgTanque from '../../assets/icons/Novotanque.png';
import { AdminContext } from '../../contexts/contexAdmin';

export const TanqueAdmin = () => {
  const { headerApi } = useContext(HomeContext);
  const {
    modalConfimation,
    setModalConfimation,
    salveTanqueInfo,
    setSalveTanqueInfo,
    modalCreatTanque,
    setModalCreatTanque,
    setModalBombaTaque,
  } = useContext(AdminContext);

  const [tanquesList, setTanquesList] = useState(null);
  const [editedTanques, SetEditedTanques] = useState({});

  const ListTanques = async () => {
    try {
      const idUnidade = sessionStorage.getItem('connectionsUnitId');

      const response = await apiJalles.get(`tanque/LeituraTodos/${idUnidade}`, headerApi);
      setTanquesList(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleInputChange = (e, tanqueId, type) => {
    SetEditedTanques((prevEditedTanque) => ({
      ...prevEditedTanque,
      [tanqueId]: {
        ...prevEditedTanque[tanqueId],
        [type]: e,
      },
    }));
  };

  useEffect(() => {
    ListTanques();
  }, [modalCreatTanque]);

  useEffect(() => {
    const initialEditedPivos = {};
    if (tanquesList != null) {
      tanquesList.forEach((tanque) => {
        initialEditedPivos[tanque.id] = { ...tanque };
      });
      SetEditedTanques(initialEditedPivos);
    }
  }, [tanquesList]);

  return (
    <AdminTanque>
      <div className="Header">
        <h2>Tanques</h2>
        <div className="addIcon">
          <div className="icons" onClick={() => setModalCreatTanque(true)}>
            <img src={imgTanque} alt="" />
            <IoAddCircle className="ADDIcon" />
          </div>
          <span>Criar Um Novo Tanque</span>
        </div>
      </div>
      <ul>
        {tanquesList &&
          tanquesList
            .sort((a, b) => a.nome_tanque.localeCompare(b.nome_tanque))
            .map((tanque) => {
              const cancelChanges = () => {
                SetEditedTanques((prevEditedTanques) => ({
                  ...prevEditedTanques,
                  [tanque.id]: {
                    ...prevEditedTanques[tanque.id],
                    nome_tanque: tanque.nome_tanque,
                    longitude: tanque.longitude,
                    latitude: tanque.latitude,
                    nivel_maximo: tanque.nivel_maximo,
                    nivel_minimo: tanque.nivel_minimo,
                    ativo: tanque.ativo,
                  },
                }));
              };

              const checkChangesTanque =
                JSON.stringify(tanque) === JSON.stringify(editedTanques[tanque.id]);

              return (
                <li>
                  <div className="headerTanqueInfo">
                    <input
                      type="text"
                      id={`${tanque.id}name`}
                      value={tanque.nome_tanque || ''}
                      onChange={(e) => handleInputChange(e.target.value, tanque.id, 'nome_tanque')}
                    />
                    <label htmlFor={`${tanque.id}name`}>
                      <CiEdit />
                    </label>
                    <ImBin
                      className="iconBin"
                      // onClick={() => {
                      //   setModalPivoDeletConfirmation(!modalPivoDeletConfirmation);
                      //   setSavePivoId(pivo.id);
                      // }}
                    />
                  </div>
                  <div className="infosPivo">
                    <label htmlFor={`${tanque.id}ID`}>ID da Tanque</label>
                    <input
                      type="number"
                      id={`${tanque.id}ID`}
                      value={editedTanques[tanque.id]?.id}
                      disabled={true}
                    />
                  </div>
                  <div className="infosPivo">
                    <label htmlFor={`${tanque.id}altura`}>Nível Máximo</label>
                    <input
                      type="number"
                      id={`${tanque.id}altura`}
                      value={editedTanques[tanque.id]?.nivel_maximo}
                      onChange={(e) => handleInputChange(e.target.value, tanque.id, 'nivel_maximo')}
                    />
                  </div>
                  <div className="infosPivo">
                    <label htmlFor={`${tanque.id}alturaMin`}>Nível Mínimo</label>
                    <input
                      type="number"
                      id={`${tanque.id}alturaMin`}
                      value={editedTanques[tanque.id]?.nivel_minimo}
                      onChange={(e) => handleInputChange(e.target.value, tanque.id, 'nivel_minimo')}
                    />
                  </div>

                  <div className="infosPivo">
                    <label htmlFor={`${tanque.id}latitude`}>Latitude</label>
                    <input
                      type="number"
                      id={`${tanque.id}latitude`}
                      value={editedTanques[tanque.id]?.latitude}
                    />
                  </div>
                  <div className="infosPivo">
                    <label htmlFor={`${tanque.id}longitude`}>Longitude</label>
                    <input
                      type="number"
                      id={`${tanque.id}longitude`}
                      value={editedTanques[tanque.id]?.longitude}
                      onChange={(e) => handleInputChange(e.target.value, tanque.id, 'longitude')}
                    />
                  </div>
                  <div className="infosPivo">
                    <label htmlFor={`${tanque.id}QdtBombas`}>Quantidades de bombas</label>
                    <input
                      type="number"
                      id={`${tanque.id}QdtBombas`}
                      value={tanque.bombas.length || 0}
                      disabled={true}
                    />
                  </div>
                  <div className="infosPivo">
                    <p>Status do Tanque</p>
                    <div className="selectBomb">
                      <span className="select">Ativado</span>
                      <button
                        onClick={() =>
                          handleInputChange(!editedTanques[tanque.id]?.ativo, tanque.id, 'ativo')
                        }
                      >
                        <Dot isLeft={editedTanques[tanque.id]?.ativo} />
                      </button>
                      <span className="select">Desativado</span>
                    </div>
                  </div>
                  <div className="buttons ">
                    <button
                      className="bombsSelect"
                      onClick={() => {
                        setModalBombaTaque(true);
                        setSalveTanqueInfo([tanque.id, editedTanques[tanque.id]]);
                      }}
                    >
                      Bombas
                    </button>
                  </div>
                  <div className="buttons">
                    <button
                      className={checkChangesTanque ? 'off' : ''}
                      disabled={checkChangesTanque}
                      onClick={() => {
                        setModalConfimation(!modalConfimation);
                        setSalveTanqueInfo([tanque.id, editedTanques[tanque.id]]);
                      }}
                    >
                      Salvar
                    </button>
                    <button disabled={checkChangesTanque} onClick={() => cancelChanges()}>
                      Cancelar
                    </button>
                  </div>
                </li>
              );
            })}
      </ul>
    </AdminTanque>
  );
};
